import styled from 'styled-components';
import { Button, palette } from '@m12s/component-library';

const IconWrapper = styled.button`
  background: transparent;
  border: 0;
  padding: 0;
  margin: 0;
`;

const modalStyles = {
  padding: 0,
};

const buttonStyles = {
  padding: '1rem 1.5rem',
  background: palette.White,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  gap: '1rem',
};

const headerStyles = {
  color: palette.Grey700,
  background: palette.White,
  borderBottom: `1px solid ${palette.Grey400}`,
  fontWeight: '500',
};

const detailsStyles = {
  fontWeight: '400',
  fontSize: '0.875rem', // 14px to rem
  lineHeight: '1.25rem', // 20px to rem
  padding: '1.5rem',
  borderBottom: `1px solid ${palette.Grey400}`,
};

const ModalButtons = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-direction: row;
`;

const ModalButton = styled(Button)`
  font-size: 0.875rem;
  text-shadow: none;
  /* Disable double-tap-to-zoom so the tap resolves immediately — prevents the
     delayed synthesized "ghost click" that could pass through to whatever sits
     beneath the modal once it dismisses. */
  touch-action: manipulation;

  ${({ customStyles }) => {
    return customStyles;
  }}
  &:hover {
    ${({ hoverStyles }) => {
      return hoverStyles;
    }}
  }
`;

export {
  IconWrapper,
  modalStyles,
  headerStyles,
  detailsStyles,
  buttonStyles,
  ModalButtons,
  ModalButton,
};
